import { useAuth } from "@/components/auth/auth-context";
import { useGetUserSupervisorMentors, UserRole } from "@/lib/api/user";

export const useShouldShowFloatingChat = () => {
  const { user } = useAuth();
  const { data: supervisors } = useGetUserSupervisorMentors(
    user?.id as string,
    user?.role === UserRole.SUPERADMIN,
  );

  const shouldShowFloatingChat = !!supervisors?.mentors?.length;

  return user?.role !== UserRole.SUPERADMIN || shouldShowFloatingChat;
};
